import { PlexUserRelationState, TaskUserRelationState } from '@all-hands-hq/plex-graphql-schema';
import { createStyles, FormControl, makeStyles, MenuItem, Select } from '@material-ui/core';
import React, { useState } from 'react';

import { PublishStatus as PublishStatusGraphQL, useUpdateTaskMutation } from '../../../../graphql/gen/types';
import { PostVisibility } from '../../common/PostVisibility';
import { canEditTask } from '../../permissions';
import { TaskField } from './common/TaskField';

type Props = {
  id: string;
  plexName: string;
  publishStatus: PublishStatusGraphQL;
  plexRelation: PlexUserRelationState;
  taskRelation: TaskUserRelationState;
};

type State =
  | { type: 'initial' }
  | {
      type: 'editing';
      value: PublishStatusGraphQL;
    };

export const TaskVisibility = ({
  id,
  plexRelation,
  taskRelation,
  publishStatus,
  plexName,
}: Props): React.ReactElement => {
  const classes = useStyles();
  const [state, setState] = useState<State>({ type: 'initial' });
  const [updateTask, { loading }] = useUpdateTaskMutation();

  return (
    <div className={classes.root}>
      {state.type === 'initial' && (
        <TaskField
          mode="view"
          label="Visibility"
          onClick={
            canEditTask({ plexRelation, taskRelation })
              ? () => {
                  setState({ type: 'editing', value: publishStatus });
                }
              : null
          }
        >
          <PostVisibility plexPublishStatus={publishStatus} plexName={plexName} />
        </TaskField>
      )}
      {state.type === 'editing' && (
        <TaskField
          mode="edit"
          label="Visibility"
          saving={loading}
          onClickAway={() => {
            setState({ type: 'initial' });
          }}
        >
          <FormControl size="small">
            <Select
              autoFocus
              value={state.value}
              onChange={(event) => {
                const value = event.target.value as PublishStatusGraphQL;
                setState({ ...state, value });
                updateTask({ variables: { task: { id, publishStatus: value } } }).then(() => {
                  setState({ type: 'initial' });
                });
              }}
              variant="outlined"
              MenuProps={{
                // disable portal to ensure ClickAwayListener does not reset the editable state
                disablePortal: true,
              }}
            >
              {[PublishStatusGraphQL.Draft, PublishStatusGraphQL.Internal, PublishStatusGraphQL.Published].map(
                (publishStatus) => (
                  <MenuItem key={publishStatus} value={publishStatus}>
                    <PostVisibility plexPublishStatus={publishStatus} plexName={plexName} />
                  </MenuItem>
                )
              )}
            </Select>
          </FormControl>
        </TaskField>
      )}
    </div>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      height: 49,
    },
  })
);
